import { inject } from "@angular/core";
import { InMemoryCache, ApolloLink } from "@apollo/client/core";
import { environment } from "@environments/environment";
import { customScalarsLink } from "@config/apollo/apollo-link.config";
import { provideApollo } from "apollo-angular";
import { HttpLink } from "apollo-angular/http";

export const apolloProvider = provideApollo(() => {
    const httpLink = inject(HttpLink);

    return {
        // Link order is important
        link: ApolloLink.from([
            customScalarsLink,
            httpLink.create({ uri: environment.api.graphqlUrl }),
        ]),
        cache: new InMemoryCache(),

    };
});
